import React, { useEffect, useState } from "react";
import "../modal.css";

export default function OffllineMessage({ offlineMsg, GAEvent }) {
  const showHideClassName = "modal display-block";
  useEffect(()=>{
    window.parent.postMessage({ message: 'Error.',chatInit: false }, '*');
  },[])

  return (
    <div className={showHideClassName}>
      <div className="constainer">
        <div className="card-layout layout-medium">
          <div className="content">
            <h1 className="title"></h1>
            <div className="feedback_message">
              <div className={`ErrorMsg`}  > {offlineMsg} </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  );
}
